<template>
  <div v-if="showPop" class="same_question_guide_answerSwiper">
    <VanOverlay :show="showPop" z-index="999" lock-scroll @click="closeOverlay">
      <div>
        <div class="question_white">
          <p>新功能上线啦！</p>
          <img
            src="https://img01.yzcdn.cn/upload_files/2021/09/14/FuhaDlEuB3_rwEM1oc_On-soJF2I.png"
          />
        </div>
        <div v-mask class="bottom_white">
          <p class="text1">点击按钮，即可查看举一反三题目</p>
          <img
            class="img1"
            src="https://img01.yzcdn.cn/upload_files/2021/09/14/Fv7klRjNDntSVopyy-qHlVmt4bqC.png"
          />
        </div>
      </div>
    </VanOverlay>
  </div>
</template>

<script>
/*
 * By Suxue
 * 2021/9/13
 */
import popRegister from '@/mixins/popRegister'
import { mapState } from 'vuex'
import { updateTreasureBox } from '@/api/user'
import { Overlay } from 'vant'

export default {
  name: 'SameQuestionGuide',
  components: {
    VanOverlay: Overlay
  },
  mixins: [popRegister],
  data() {
    return {
      popupName: 'SameQuestionAnswerGuide',
      keyName: 'SQAnswer',
      showPop: false,
      resetElementTopLayer: null,
      actionEnd: false
    }
  },
  computed: {
    ...mapState('user', ['userInfo'])
  },
  mounted() {},
  methods: {
    openAction() {
      const {
        userInfo: { treasureBox },
        keyName
      } = this
      const hasOpen = String(treasureBox).includes(keyName)
      if (hasOpen) {
        this.dealClose()
        return
      }
      // 返回页面顶部，以防止定位错误
      window.scrollTo(0, 0)
      this.showPop = true
      this.$nextTick(() => {
        document.querySelector(
          '.same_question_guide_answerSwiper .question_white'
        ).style.opacity = 1
        setTimeout(() => {
          document.querySelector(
            '.same_question_guide_answerSwiper .bottom_white'
          ).style.opacity = 1
          // 置顶锚点元素
          document.querySelector('.answer_page .tool').style.cssText = 'position: absolute'
          document.querySelector('.answer_page .tool .juyifansanTool').style.cssText =
            'position: relative; z-index: 99999'
          this.actionEnd = true
        }, 1500)
      })
    },
    closeOverlay() {
      if (this.actionEnd) {
        this.close()
      }
    },
    closeAction() {
      this.showPop = false
      try {
        document.querySelector('.answer_page .tool').style.position = 'fixed'
        document.querySelector('.answer_page .tool .juyifansanTool').style.cssText =
          'position: relative; z-index: 0'
        this.$pop.next()
        updateTreasureBox({
          keyName: this.keyName
        })
      } catch (e) {}
    }
  }
}
</script>

<style lang="scss" scoped>
.same_question_guide_answerSwiper {
  .question_white {
    position: absolute;
    top: 100px;
    padding: 0 14px;
    opacity: 0;
    transition: opacity 0.5s ease-in;
    p {
      font-size: 20px;
      color: #ffffff;
      margin-bottom: 14px;
    }
    img {
      width: 185px;
    }
  }
  .bottom_white {
    position: absolute;
    width: 63px;
    height: 50px;
    bottom: 6px;
    left: 157px;
    opacity: 0;
    background: #ffffff;
    border-radius: 5px;
    transition: opacity 0.5s ease-in;
    .text1 {
      position: absolute;
      top: -60px;
      left: -78px;
      white-space: nowrap;
      font-weight: 300;
      font-size: 16px;
      color: #ffffff;
    }
    .img1 {
      position: absolute;
      top: -27px;
      left: -54px;
      width: 48px;
    }
  }
}
.nav_links_wrap_guide {
  position: absolute;
  width: 181px;
  height: 188px;
  left: 8px;
  top: 49px;
  background: #ffffff;
  border-radius: 28px 28px 10px 28px;
}
.nav_links_text_guide {
  position: absolute;
  top: 250px;
  left: 23px;
  font-size: 16px;
  white-space: nowrap;
  color: #ffffff;
}
.icon_wrap_guide {
  width: 360px;
  height: 97.25px;
  background: #ffffff;
  top: 238px;
  border-radius: 17px;
}
.icon_wrap_guide_shou {
  top: 350px;
}
.icon_wrap_guide_img {
  width: 60px;
}
.icon_wrap_guide_text {
  white-space: nowrap;
  margin-top: 12px;
  font-size: 16px;
  color: #ffffff;
}
.answer_guide_but {
  width: 110px;
  margin-top: 12px;
}
</style>
